import { z } from "zod";
import { CommunityItemType, CommunityReportReason } from "./enums.js";
export const ReportCommunityItemRequest = z.object({
    itemType: CommunityItemType.exclude(["milestone"]),
    itemId: z.string().uuid(),
    reason: CommunityReportReason,
    note: z.string().trim().max(1200).optional(),
});
export const ReportCommunityItemResponse = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=report.js.map